export enum OrderSortOrder {
    DESCENDANT = "DESC",
    ASCENDANT = "ASC"
}
